import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useFiltersContext } from '../../hooks';
import { FilterValue, RegisterFunction } from '../../types/filter.types';
import { CalendarInput, DateRange } from '@nexelem/components';

type DateRagePickerFilterProps = {
  label: string;
  path: string;
  register: RegisterFunction;
};

export const DateRagePickerFilter = ({ register, path, label }: DateRagePickerFilterProps) => {
  const { filters, onChange } = useFiltersContext();

  const filterValue = get(filters, path, {
    value: {},
    key: '',
  } as FilterValue<DateRange>) as FilterValue<DateRange>;

  useEffect(() => {
    register({
      path,
      isMultiple: false,
      value: null,
    });
  }, [path, register]);

  const handleDateChange = useCallback(
    (value: DateRange | undefined) => {
      onChange(path, {
        value: {
          from: value?.from,
          to: value?.to,
        },
        isMultiple: false,
      });
    },
    [onChange, path],
  );

  return <CalendarInput label={label} mode="range" selected={filterValue.value} onSelect={handleDateChange} />;
};
